import React, { useEffect } from 'react';
import { Button, Card } from 'antd';
// import { useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import Main from '../../components/layout/Main';
import BreadcrumbNav from '../../components/layout/BreadcrumbNav';
import Logout from '../../components/Logout';
import { AppDispatch, CombinedStates } from '../../core/types';

import './indicatorDataImport.scss';
import SchoolIndicatorsImport from '../../components/IndicatorStatisticsComponents/SchoolIndicatorsImport';

const IndicatorDataImport = () => {
    const dispatch = useDispatch<AppDispatch>();
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];
    const {
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const backLink = (
        <Button onClick={() => console.log('Back')}>
            <LeftOutlined /> BACK
        </Button>
    );

    return (
        <Main
            className="login"
            title={<div>Mokyklų rodiklių duomenų importavimas</div>}
            headerTitle={<div>Mokyklų rodiklių duomenų importavimas</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div style={{ lineHeight: '30px', fontSize: '16px', float: 'right' }}>&copy; copyright 2020</div>}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <SchoolIndicatorsImport />
        </Main>
    );
};

export default IndicatorDataImport;

IndicatorDataImport.propTypes = {};
